module.exports = __webpack_public_path__ + "img/md-staff-logs.9c7df60b.png";